export const BASE_URL: string =
  'http://localhost:8000';
export const BACKEND_URL: string =
  process.env.REACT_APP_BACKEND_URL as string;
//  'http://localhost/api/v1';
//  'https://demo.hdks.co.jp/api/v1';
export const REACT_APP_AUTH_TOKEN_NAME: string =
  'token';